import React, { useState } from 'react'
import { Box, Card } from 'pcln-design-system'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import StyledHeading from '@/components/StyledHeading'
import useSEMSearchHeadline from '@/hooks/useSEMSearchHeadline'
import CONTENT, { GREETING_DESKTOP } from '@/constants/content'
import useCityNameInFormHeadlineForSEM from '@/hooks/useCityNameInFormHeadlineForSEM'
import useSeti from '@/hooks/useSeti'
import { LOCATION_SEARCH_TYPE, ProductType } from '@/types'
import useBootstrapData from '@/hooks/useBootstrapData'
import getCurrentTab from '@/shared-utils/getCurrentTab'
import SearchFormProvider from '../../context/SearchFormContext'
import Tabs from './Tabs'
import useHeadlineValues from './customHooks/useHeadlineValues'
import getProductCategory from './utils/getProductCategory'

const StyledCard = styled(Card)`
  border-radius: 24px 24px 6px 6px;
`

const getHeadlineWithFirstName = (template: string, firstName: string) =>
  firstName ? template.replace('{firstName}', firstName) : GREETING_DESKTOP

export default function SearchFormDesktop() {
  const { query } = useRouter()
  const currentTab = getCurrentTab(query)

  const {
    customer: { firstName },
    signInStatus: { signedIn, passiveSignIn }
  } = useBootstrapData()
  const isSignedIn = signedIn || passiveSignIn
  const [location, setLocation] = useState<LOCATION_SEARCH_TYPE | undefined>()
  const prePopHeadline = useCityNameInFormHeadlineForSEM(location)
  const SEMHeadline = useSEMSearchHeadline()
  const headlineValues = useHeadlineValues(currentTab)

  const headlineWithName = getHeadlineWithFirstName(
    CONTENT.homepage.vip.headlineWithName,
    firstName
  )
  const defaultHeadline = isSignedIn
    ? headlineWithName
    : headlineValues.hotels.headline
  const hotelHeadline = prePopHeadline || SEMHeadline || defaultHeadline
  headlineValues.hotels.headline = hotelHeadline

  const showMultiHotel = useSeti('PKG_FE_HH_HOTEL_HOME_PAGE') === 'VARIANT'

  const [formState, setFormState] = useState(
    getProductCategory(currentTab, headlineValues, setLocation, showMultiHotel)
  )
  const handleOnClick = (productType: ProductType) => {
    const selectedProductCategory = getProductCategory(
      productType,
      headlineValues,
      setLocation,
      showMultiHotel
    )
    setFormState(selectedProductCategory)
  }
  return (
    <Box>
      <StyledHeading
        pl={0}
        pb={[16, null, null, null, 4]}
        pr={[0, null, null, null, '130px']}
        tag="h1"
        color="text.heading"
        text={formState.headline}
        mx={[4, null, null, null, 0]}
        textStyle={['heading2', 'heading3', null, 'heading2', null, 'heading1']}
      />
      <Card
        boxShadowSize="xl"
        borderWidth={0}
        borderRadius="2xl"
        minWidth={[null, null, null, '720px']}
        color="background.lightest"
        mx={[4, null, null, null, 0]}
      >
        <StyledCard boxShadowSize="none" borderWidth={0}>
          <Box pt={3}>
            <Tabs onClick={handleOnClick} />
          </Box>
        </StyledCard>
        <SearchFormProvider>
          <Box
            p={3}
            id={`panel-${currentTab}`}
            aria-labelledby={`tab-${currentTab}`}
          >
            {formState.component}
          </Box>
          <Box>{formState.bumper}</Box>
        </SearchFormProvider>
      </Card>
    </Box>
  )
}
